var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDailyYellow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEC\xB6\x9C\xEC\x84\x9D\xEC\x9D\xB4\xEB\xAA\xA8\xEC\xA7\x80",
    clipPath: "url(#clip0_283_1653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.1 2.1001H6.9C4.24903 2.1001 2.1 4.24913 2.1 6.9001V17.1001C2.1 19.7511 4.24903 21.9001 6.9 21.9001H17.1C19.751 21.9001 21.9 19.7511 21.9 17.1001V6.9001C21.9 4.24913 19.751 2.1001 17.1 2.1001Z",
    fill: "#FFCD00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.127 14.6586V7.63325C17.127 7.21325 16.7868 6.87305 16.3668 6.87305H9.3414C8.9922 6.87305 8.817 7.29545 9.0642 7.54265L10.782 9.26045C10.9524 9.43085 10.9524 9.70745 10.782 9.87785L6.9822 13.6776C6.8376 13.8222 6.8376 14.0568 6.9822 14.202L9.798 17.0178C9.9426 17.1624 10.1772 17.1624 10.3224 17.0178L14.1222 13.218C14.2926 13.0476 14.5692 13.0476 14.7396 13.218L16.4574 14.9358C16.7046 15.183 17.127 15.0078 17.127 14.6586Z",
    fill: "#313D4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_283_1653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyYellow);
export default __webpack_public_path__ + "static/media/daily_yellow.a0bd957587290c53648e72aeef407d1b.svg";
export { ForwardRef as ReactComponent };